<template>
  <div class="m-content" >
  	<HeaderBox/>
    <div class="report-content">
      <div class="report-area">
        <p class="report-title">你的毕业去向决策平衡单</p>
        <img class="report-img score-img":src=balanceImage />
      </div>
    </div>
  	<FootBox :id="id"/>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import qs from 'qs'
import HeaderBox from '@/components/mission/headerBox.vue'
import FootBox from '@/components/mission/footBox.vue'
export default {
  props: {
    id: Number
  },
  name: 'DecisionMakingReport',
  components: {
    HeaderBox,
    FootBox
  },
  data() {
    return {
      balanceImage:'',
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },  
  created: function () {
    this.getReport()
  },
  methods:{
    getReport(){
        const options = {
          method: 'post',
          headers: {'content-type': 'application/x-www-form-urlencoded'},
          data: qs.stringify({
            openId: this.shengyaUser.openid
          }),          
          url:'/cob/cosBalanceReport.do'
        };
        axios(options)
        .then((response)=>{
          if(response.data.result.success){
            let Result = response.data.data;
            if(Result){
              this.balanceImage=Result.cosBalance.balanceImage
              // 弹幕
              let scoreBank = Result.cosBalance.listScoreRank,
              num = Math.round(Math.random()*2),
              text='最合适的选择是'+scoreBank[0].goal
              if(num==1){
                text='最符合初心的毕业去向是'+scoreBank[0].goal
              }else if(num==2){
                text='最感兴趣的三个毕业去向是'+scoreBank[0].goal+'、'+scoreBank[1].goal+'、'+scoreBank[2].goal
              }
              if(text){
                store.dispatch('finishPlay', {missionId:this.id,cosAnswer:text})
              }
            }
          }
        })
        .catch((error)=>{
          console.log(error);
        })
    }
  }
}
</script>
<style scoped>
</style>
